import { render, staticRenderFns } from "./inviteOrder.vue?vue&type=template&id=975bc15c&scoped=true&"
import script from "./inviteOrder.vue?vue&type=script&lang=js&"
export * from "./inviteOrder.vue?vue&type=script&lang=js&"
import style0 from "./inviteOrder.vue?vue&type=style&index=0&id=975bc15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975bc15c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('975bc15c')) {
      api.createRecord('975bc15c', component.options)
    } else {
      api.reload('975bc15c', component.options)
    }
    module.hot.accept("./inviteOrder.vue?vue&type=template&id=975bc15c&scoped=true&", function () {
      api.rerender('975bc15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/invite/inviteOrder.vue"
export default component.exports